//Packages
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Overlay, Popover } from "react-bootstrap";

//Components
import AISummaryContent from "./AISummaryContent";
import AISummaryModalSkeleton from "./AISummaryModalSkeleton";

//Actions
import {
  setMessage,
  setReaction,
  saveReaction,
  clearReactions,
  closePopup,
} from "../../Actions/AINewsActions";


const AISummaryModal = ({
  showPopup,
  hidePopup,
  target,
  isReqActive,
  data,
  message,
  setMessage,
  maxWidth,
  placement,
  width,
  className,
  newsType,
  selectedSegment,
  transform,
  setReaction,
  saveReaction,
  clearReactions,
  financialDetails,
  popoverPosition,
  closePopup,
  trackPriceDate,
  top,
}) => {
  const popoverRef = useRef(null);
  const trackPriceDateRef = useRef(trackPriceDate);
  const [transformArrow, setTransformArrow] = useState(0)
  const [isAutoScrolling, setIsAutoScrolling] = useState(false);
  const [userScrolled, setUserScrolled] = useState(false);
  const autoScrollTimeoutRef = useRef(null);

  useEffect(() => {
    clearReactions();
    trackPriceDateRef.current = trackPriceDate;
  }, [trackPriceDate]);


  const handleReaction = (index, text, reaction, comments, date) => {
    saveReaction(index, text, reaction, comments, date);
  };
  useEffect(() => {
    clearReactions();
    const handleClickOutside = (event) => {
      const popoverElement = document.getElementById("ai-summary-popover");
      const customWrapper = document.getElementById("trackPriceAiNewsDiv");
      const reactionPopoverElement = document.getElementById("reaction-popover");
      const clickedInsidePopover = popoverElement && popoverElement.contains(event.target);
      const clickedInsideCustomWrapper = customWrapper && customWrapper.contains(event.target);
      const clickedInsideReaction = reactionPopoverElement && reactionPopoverElement.contains(event.target);

      if (!clickedInsidePopover && !clickedInsideCustomWrapper && !clickedInsideReaction && showPopup) {
        hidePopup(event);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      setReaction(newsType, selectedSegment, financialDetails, trackPriceDateRef.current);
      closePopup();
    };
  }, []);


  useEffect(() => {
    let timeoutId;

    if (isReqActive) {
      timeoutId = setTimeout(() => {
        setMessage("It is taking time, Please wait ...");
      }, 10000);
    }

    return () => clearTimeout(timeoutId);
  }, [isReqActive]);

  // Attach manual scroll listener to popover content to detect user scrolls
  useEffect(() => {
    const el = document.getElementsByClassName("popover-content")[0];
    if (!el) return;

    const onScroll = (e) => {
      if (!isAutoScrolling) {
        const target = e.target;
        const isAtBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 10;
        if (!isAtBottom) {
          setUserScrolled(true);
        } else {
          setUserScrolled(false);
        }
      }
    };

    el.addEventListener('scroll', onScroll);
    return () => {
      el.removeEventListener('scroll', onScroll);
    };
  }, [isAutoScrolling]);

  useEffect(() => {
    const el = document.getElementsByClassName("popover-content")[0];
    if (top) {
      const popoverElement = document.getElementById("ai-summary-popover") || document.getElementById("trackPriceAiNewsDiv");
      const popoverRect = popoverElement?.getBoundingClientRect();
      if ( popoverRect && popoverRect.height / 2 > top - 10 ) {
        setTransformArrow((popoverRect.height / 2 - top + 10))
      }
    }

    // Auto-scroll to bottom when content updates and user hasn't scrolled away
    if (el && !userScrolled) {
      setIsAutoScrolling(true);
      el.scrollTop = el.scrollHeight;
      if (autoScrollTimeoutRef.current) {
        clearTimeout(autoScrollTimeoutRef.current);
      }
      autoScrollTimeoutRef.current = setTimeout(() => {
        setIsAutoScrolling(false);
      }, 100);
    }
  }, [data, userScrolled, top]);

  // Auto-scroll on open/show of the popover as well
  useEffect(() => {
    if (!showPopup) return;
    const scrollToBottom = () => {
      const el = document.getElementsByClassName("popover-content")[0];
      if (el && !userScrolled) {
        setIsAutoScrolling(true);
        el.scrollTop = el.scrollHeight;
        if (autoScrollTimeoutRef.current) {
          clearTimeout(autoScrollTimeoutRef.current);
        }
        autoScrollTimeoutRef.current = setTimeout(() => {
          setIsAutoScrolling(false);
        }, 100);
      }
    };
    // delay to ensure DOM is laid out
    const id = setTimeout(scrollToBottom, 0);
    return () => clearTimeout(id);
  }, [showPopup, userScrolled]);

  // Reset scroll behavior when reopening
  useEffect(() => {
    if (showPopup) {
      setUserScrolled(false);
      setIsAutoScrolling(false);
      if (autoScrollTimeoutRef.current) {
        clearTimeout(autoScrollTimeoutRef.current);
      }
    }
  }, [showPopup]);

  // Cleanup timeout on unmount
  useEffect(() => () => {
    if (autoScrollTimeoutRef.current) {
      clearTimeout(autoScrollTimeoutRef.current);
    }
  }, []);

  return (
    <Overlay
      show={showPopup}
      target={target}
      style={{
        marginTop: !popoverPosition ? "10px" : null,
      }}
      placement={placement}
      container={document.body}
      containerMargin={10}
      containerPadding={10}
      shouldUpdatePosition={true}
    >
      {
        popoverPosition ?
        // warpper component need to display div at custom location using Overlay
          <PopperWrapper
            className={className}
            popoverPosition={popoverPosition}
            message={message}
            width={width}
            data={data}
            handleReaction={handleReaction}
            newsType={newsType}
          />
          :
          <Popover
            id="ai-summary-popover"
            ref={popoverRef}
            className={`summary-popover ${className}`}
            style={{
              marginTop: 0,
              width: width ? width : null,
              maxWidth: maxWidth,
              minHeight: "80px",
              transform: `translate(${transform})`,
              '--popover-arrow-top': `calc(50% - 7px${transformArrow ? ` - ${transformArrow}px` : ''})`,
            }}
            onMouseDown={(event) => event.nativeEvent?.stopImmediatePropagation()}
          >
            {message ? (
              <AISummaryModalSkeleton width={width || "500px"} />
            ) : (
              <AISummaryContent
                data={data}
                handleReaction={handleReaction}
                newsType={newsType}
              ></AISummaryContent>
            )}
            <div id="popover-arrow-hide"></div>
          </Popover>
      }
    </Overlay>
  );
};

AISummaryModal.defaultProps = {
  placement: "bottom",
  maxWidth: "500px",
  width: null,
  className: null,
  transform: "0px, 0px",
};

const mapStateToProps = ({ aiNewsReducer }) => {
  const { message, isReqActive } = aiNewsReducer;

  return { message, isReqActive };
};

const mapDispatchToProps = (dispatch) => ({
  setMessage: (msg) => dispatch(setMessage(msg)),
  setReaction: (newsType, selectedSegment, financialDetails, trackPriceDate) =>
    dispatch(setReaction(newsType, selectedSegment, financialDetails, trackPriceDate)),
  saveReaction: (index, text, reaction, comments, date) =>
    dispatch(saveReaction(index, text, reaction, comments, date)),
  clearReactions: () => dispatch(clearReactions()),
  closePopup: () => dispatch(closePopup()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AISummaryModal);

const PopperWrapper = ({ className, popoverPosition, message, data, handleReaction, newsType, width }) => (
  <div
    id="trackPriceAiNewsDiv"
    className={className}
    style={{
      position: 'absolute',
      ...popoverPosition,
    }}
  >
    {message ? (
      <AISummaryModalSkeleton width={width || "500px"} />
    ) : (
      <AISummaryContent
        data={data}
        handleReaction={handleReaction}
        newsType={newsType} />
    )}
  </div>
)
